// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

document.addEventListener('DOMContentLoaded', () => {
  const portfolioSliders = document.querySelectorAll('.a-portfolio-slider')

  portfolioSliders.forEach((slider) => {
    const portfolioSlider = slider.querySelector('.swiper-container')
    const pagination = slider.querySelector('.swiper-pagination')

    const portfolioSwiper = new Swiper(portfolioSlider, {
      speed: 800,
      watchOverflow: true,
      pagination: {
        el: pagination,
        clickable: true
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000
      },
      allowTouchMove: false
    })
    portfolioSwiper.init()
  })
})
